import { render, staticRenderFns } from "./ManageRole.vue?vue&type=template&id=15a32b4f"
import script from "./ManageRole.vue?vue&type=script&lang=js"
export * from "./ManageRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports